import { FormTemplate } from "components/modal/templates";
import React, { Fragment } from "react";
import { applyItem } from "sources/extendedProperties";
import { config, initialState } from "./extendedPropertyConfig";

class ExtendedPropertyForm extends FormTemplate {
    sendRequest = (stateData) => {
        return applyItem(stateData);
    };

    renderBodyInner = () => {
        const { config } = this.props;
        return (
            <Fragment>
                {this.renderField(config.defaultValue)}
                {this.renderField(config.displayName)}
                {this.renderField(config.description)}
                {this.renderField(config.domainCode)}
                {this.renderFlags(config.intFlags)}
                {this.renderSelect(config.kind)}
                {this.renderField(config.propertyName)}
                {this.renderSelect(config.typeCode)}
                {this.renderField(config.validationRegexMask)}
            </Fragment>
        );
    };
}

const ConfiguredModal = (props) => {
    const componentInitialState = {};
    Object.keys(config).forEach((key) => {
        componentInitialState[key] = props.data[key] || initialState[key];
    });
    return <ExtendedPropertyForm {...props} config={config} initialState={componentInitialState} />;
};

export default ConfiguredModal;
